export default __webpack_public_path__ + "static/media/login-brand-image-3-white.4073b6bb.jpg";